import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useDeleteSavedView() {
  const queryClient = useQueryClient()

  const action = async (id) => {
    await httpClient.delete(`team/saved-views/${id}`)
  }

  const mutation = useMutation({
    mutationFn: action,
    onSuccess: () => {
      toast.success('View deleted.')
      queryClient.invalidateQueries({ queryKey: ['saved-views'] })
    },
    onError: () => {
      toast.error("Couldn't delete the view.")
    },
  })

  return { action: mutation.mutateAsync, status: mutation }
}
